import React from 'react';

export const GenericFormContext = React.createContext({
    ocrAmountValue: "0",
    getAmountFromOcrData: () => {},
    inputWidth: 47,
    calculateInputWidth: () => {},
    selectedItemId: "0",
    handleClickSelectedChip: () => {},
    selectedItemAmount: 0,
    handleSetAmountFromInput: () => {},
    setAmountFromInput: false,
    countPaymentMethodsCall: 0,
    setCountPaymentMethods: () => {}
});

export class GenericFormContextProvider extends React.Component {
  constructor(props) {
    super(props);
    this.getAmountFromOcrData = this.getAmountFromOcrData.bind(this);
    this.calculateInputWidth = this.calculateInputWidth.bind(this);
    this.handleClickSelectedChip = this.handleClickSelectedChip.bind(this);
    this.handleSetAmountFromInput = this.handleSetAmountFromInput.bind(this);
    this.setCountPaymentMethods = this.setCountPaymentMethods.bind(this);
    this.state = { 
      ocrAmountValue: "0", 
      inputWidth: 47,
      selectedItemId: "0",
      selectedItemAmount: 0,
      setAmountFromInput: false,
      countPaymentMethodsCall: 0
    };
  }

  getAmountFromOcrData(amount) {
    let amountString = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    this.setState({ ocrAmountValue: amountString });
    let newLength = this.calculateInputWidth(amountString);
    this.setState({ inputWidth: newLength });
  }

  calculateInputWidth(amount){
    let amountString = String(amount);
    let commasRepeates = amountString.split(",").length-1;
    let dotsRepeated = amountString.split(".").length-1;
    let newLength =  (amountString.length * 47) - ((commasRepeates + dotsRepeated) * 26);
    return (amount == 0)?47:newLength;
  }

  handleClickSelectedChip(selectedItem){
    this.setState({ 
      selectedItemId: selectedItem.selectedItemId,
      selectedItemAmount: selectedItem.selectedItemAmount
    });

  }

  handleSetAmountFromInput(value){
    this.setState({ setAmountFromInput: value});
  }

  setCountPaymentMethods(value, limit){
    if(value <= limit ){
      this.setState({ countPaymentMethodsCall: value});
    }
  }

  render() {
    const { children } = this.props;

    const { ocrAmountValue, inputWidth, setAmountFromInput, countPaymentMethodsCall  } = this.state;
    return (
      <GenericFormContext.Provider
        value={{
            ocrAmountValue: ocrAmountValue,
            getAmountFromOcrData: this.getAmountFromOcrData,
            inputWidth: inputWidth,
            calculateInputWidth: this.calculateInputWidth,
            selectedItemId: this.state.selectedItemId,
            selectedItemAmount: this.state.selectedItemAmount,
            handleClickSelectedChip: this.handleClickSelectedChip,
            handleSetAmountFromInput: this.handleSetAmountFromInput,
            setAmountFromInput: setAmountFromInput,
            countPaymentMethodsCall: countPaymentMethodsCall,
            setCountPaymentMethods: this.setCountPaymentMethods
        }}>
        {children}
      </GenericFormContext.Provider>
    );
  }
}
